<div class="table-fms">
  <table>
    <thead>
    <tr>
      <th class="fix-w-10p25">Industry</th>
      <th *ngFor="let period of data[chartType].periods" class="fix-w-9">{{ period }}</th>
      <th class="fix-w-100pcnt"></th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let industry of data[chartType].industries">
      <tr>
        <td [attr.data-qa]="'ma-top-5-table-ind-'+ industry.industryName">{{ industry.industryName }}</td>
        <td *ngFor="let value of industry.values; let i = index" [attr.data-qa]="'ma-top-5-table-value-'+ industry.industryName + '-' + data[chartType].periods[i]">
            {{ value | switcherDashBraces : 1 : 2: false : '' : '%' }}
        </td>
        <td></td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>
